// LoanFaciliyList?projectId=1

import { createSlice } from "@reduxjs/toolkit";

import { createApiThunk, updateState } from "../utilityFunction"

// Initial State
const initialState = {
    fetchLoanFaciliy: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
    saveLoanFacility: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
};

// Async Thunk for Fetching Setting Data
export const fetchLoanFaciliyData = createApiThunk("loanFaciliy", "fetch")
export const saveLoanFaciliyData = createApiThunk("loanFaciliy", "save")

// Slice
const loanFaciliySlice = createSlice({
    name: "loanFaciliy",
    initialState,

    reducers: {
        resetLoanState: (state, action) => {
            const type = action.payload; // Assuming the type is passed in the action's payload

            if (type === "fetch") {
                state.fetchLoanFaciliy = {
                    ...state.fetchLoanFaciliy, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            } else if (type === "save") {
                state.saveLoanFacility = {
                    ...state.saveLoanFacility, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            }
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchLoanFaciliyData.pending, (state) => updateState(state, "pending", "fetchLoanFaciliy"))
            .addCase(fetchLoanFaciliyData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "fetchLoanFaciliy", action.payload.data))
            .addCase(fetchLoanFaciliyData.rejected, (state, action) =>
                updateState(state, "rejected", "fetchLoanFaciliy", action.payload))
            // Save data
            .addCase(saveLoanFaciliyData.pending, (state) => updateState(state, "pending", "saveLoanFacility"))
            .addCase(saveLoanFaciliyData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "saveLoanFacility", action.payload.data))
            .addCase(saveLoanFaciliyData.rejected, (state, action) =>
                updateState(state, "rejected", "saveLoanFacility", action.payload));
    },
});

export const { resetLoanState } = loanFaciliySlice.actions;
export default loanFaciliySlice.reducer;
